import { RegistrationForm, Section, Container } from '../../components';

const RegistrationPage = () => {
  return (
    <Section>
      <Container>
        <RegistrationForm />
      </Container>
      {/* <BackgroundContainer> */}

      {/* </BackgroundContainer> */}
    </Section>
  );
};

export default RegistrationPage;
